import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { IonButton, IonButtons, IonHeader, IonIcon, IonMenuToggle, NavController } from '@ionic/angular';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RoutingSegment } from '../../entities/routing-segment';
import { ToolbarService } from '../../services/toolbar/toolbar.service';
import { ConfigService } from '../../../config/services/config.service';
import { CurafidaAuthService } from '../../../authentication/curafida-auth.service';
import { StyleService } from '../../services/style/style.service';
import { patientHistorySections } from '../../../config/resources/configuration.resource';
import type { PatientHomeTabId } from '../../pages/home-patient/home-patient-page.component';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'toolbar-patient',
    templateUrl: './toolbar-patient.component.html',
    styleUrls: ['./toolbar-patient.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonIcon, IonHeader, IonMenuToggle, IonButtons],
})
export class ToolbarPatientComponent {
    readonly authService = inject(CurafidaAuthService);
    readonly configService = inject(ConfigService);
    readonly toolbarService = inject(ToolbarService);
    readonly router = inject(Router);
    private readonly navCtrl = inject(NavController);
    /** The first tab of the patient home page, in its bar order, which the home button leads back to */
    protected readonly tab = computed<PatientHomeTabId | undefined>(() => {
        const backendFeatures = this.configService.config()?.configuration?.features;
        const frontendFeatures = this.configService.frontendConfig()?.features;
        if (backendFeatures?.user?.patient?.planer?.enabled) return 'journal';
        if (patientHistorySections(frontendFeatures?.measurement, backendFeatures).length > 0) return 'chart';
        if (backendFeatures?.chat?.enabled) return 'chat';
        if (backendFeatures?.announcement?.enabled) return 'announcement';
        if (backendFeatures?.catalog?.enabled) return 'shop';
        return undefined;
    });

    openProfile(): void {
        this.router.navigate([RoutingSegment.MEMBER, RoutingSegment.PROFILE]);
    }

    protected backToHome() {
        const isLoggedIn = Boolean(this.authService.loggedInUser());
        if (!isLoggedIn) {
            if (this.router.url.includes('shop')) {
                this.navCtrl.navigateBack(['shop', 'main']);
                return;
            }
            if (this.router.url.includes('register')) {
                return;
            }
        }
        if (this.router.url.includes('article') || this.router.url.includes('program')) {
            this.router.navigate(['member', 'patient', 'home'], {
                queryParams: { home: 'shop', shop: null, program: null, article: null },
                queryParamsHandling: 'merge',
                replaceUrl: true,
            });
        } else {
            this.router.navigate(['member', 'patient', 'home'], {
                queryParams: { home: this.tab() },
                queryParamsHandling: 'merge',
            });
        }
    }
}
